<script>
/* global axios */
import LoadingState from 'dashboard/components/widgets/LoadingState.vue';

export default {
  components: {
    LoadingState,
  },
  props: {
    config: {
      type: Array,
      default: () => [],
    },
    currentChat: {
      type: Object,
      default: () => ({}),
    },
    isVisible: {
      type: Boolean,
      default: false,
    },
    position: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      hasOpenedAtleastOnce: false,
      iframeLoading: true,
    };
  },
  computed: {
    dashboardAppContext() {
      return {
        conversation: this.currentChat,
        contact: this.$store.getters['contacts/getContact'](this.contactId),
        currentAgent: this.currentAgent,
      };
    },
    contactId() {
      return this.currentChat?.meta?.sender?.id;
    },
    currentAgent() {
      const { id, name, email } = this.$store.getters.getCurrentUser;
      return { id, name, email };
    },
  },
  watch: {
    isVisible() {
      if (this.isVisible) {
        this.hasOpenedAtleastOnce = true;
      }
    },
  },
  mounted() {
    window.addEventListener('message', this.triggerEvent);
  },
  unmounted() {
    window.removeEventListener('message', this.triggerEvent);
  },
  methods: {
    triggerEvent(event) {
      if (!this.isVisible) return;
      if (
        event.data === 'chatwoot-dashboard-app:fetch-info' ||
        event.data?.type === 'wessal.panel.ready.v1'
      ) {
        this.onIframeLoad(0);
      }
    },
    getFrameId(index) {
      return `dashboard-app--frame-${this.position}-${index}`;
    },
    async onIframeLoad(index) {
      // A possible alternative is to use ref instead of document.getElementById
      // However, when ref is used together with v-for, the ref you get will be
      // an array containing the child components mirroring the data source.
      const frameElement = document.getElementById(this.getFrameId(index));
      const frameUrl = new URL(this.config[index].url, window.location.origin);
      const wessalFramePaths = new Set([
        '/wessal/conversation',
        '/wessal/comments',
        '/wessal/dashboard',
        '/wessal/operations',
        '/wessal/settings/ai',
      ]);
      if (
        frameUrl.origin === window.location.origin &&
        wessalFramePaths.has(frameUrl.pathname)
      ) {
        const accountId = String(this.$route.params.accountId);
        let response;
        try {
          response = await axios.post(
            `/api/v1/accounts/${encodeURIComponent(accountId)}/wessal_session_assertion`
          );
        } catch {
          return;
        }
        const { assertion } = response.data ?? {};
        if (typeof assertion !== 'string' || assertion.length > 4096) return;
        frameElement.contentWindow.postMessage(
          {
            type: 'wessal.panel.bootstrap.v1',
            workspaceAdapterKey: 'chatwoot',
            workspaceAccountId: accountId,
            workspaceConversationId: String(this.currentChat.id),
            workspaceUserId: String(this.currentAgent.id),
            contextNonce: crypto.randomUUID(),
            sessionCredential: assertion,
          },
          frameUrl.origin
        );
        this.iframeLoading = false;
        return;
      }
      const eventData = { event: 'appContext', data: this.dashboardAppContext };
      frameElement.contentWindow.postMessage(
        JSON.stringify(eventData),
        frameUrl.origin
      );
      this.iframeLoading = false;
    },
  },
};
</script>

<!-- eslint-disable-next-line vue/no-root-v-if -->
<template>
  <div v-if="hasOpenedAtleastOnce" class="dashboard-app--container">
    <div
      v-for="(configItem, index) in config"
      :key="index"
      class="dashboard-app--list"
    >
      <LoadingState
        v-if="iframeLoading"
        :message="$t('DASHBOARD_APPS.LOADING_MESSAGE')"
        class="dashboard-app_loading-container"
      />
      <iframe
        v-if="configItem.type === 'frame' && configItem.url"
        :id="getFrameId(index)"
        :src="configItem.url"
        @load="() => onIframeLoad(index)"
      />
    </div>
  </div>
</template>

<style scoped>
.dashboard-app--container,
.dashboard-app--list,
.dashboard-app--list iframe {
  height: 100%;
  width: 100%;
}

.dashboard-app--list iframe {
  border: 0;
}
.dashboard-app_loading-container {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  width: 100%;
}
</style>
